import React from 'react'
import {connect} from 'react-redux'
import {Link} from 'react-router'
import styles from './Messages.scss'
import {experienceMessageSelectors, experienceMessageActions} from 'data/resources/experienceMessages'
import {SectionBox} from 'common/styleguide/SectionBox'
import {Loadable} from 'common/Loadable'
import {Icon} from 'common/Icon'
import {clampString} from 'lib/utils'
import smartDate from '@qrohlf/smart-date'

export class _Messages extends React.PureComponent {
  render () {
    const {experience, messagesForExperience} = this.props

    return (
      <SectionBox title='Messages'>
        {messagesForExperience.size > 0
          ? messagesForExperience.map(message => <ExperienceMessageRow
            key={message.id}
            message={message} />)
          : <EmptyMessages />}
        <Link to={`/experiences/${experience.id}/messages`} className={styles.viewMessagesLink}>View Messages</Link>
      </SectionBox>
    )
  }
}

const ExperienceMessageRow = ({message}) => {
  return <div
    className={styles.row}>
    <div className={styles.content}>
      {clampString(message.content, 80)}
    </div>
    <div className={styles.createdAt}>
      {smartDate(message.createdAt, {relative: 'day'})}
    </div>
  </div>
}

const EmptyMessages = () => <div className={styles.empty}>
  <Icon i='empty-messages' size={40} />
  <div className={styles.explainer}>Create and send messages to your guests so they receive the most up to date information.</div>
</div>

const LoadableMessages = (props) => {
  return <Loadable
    {...props}
    component={_Messages}
    loadingText='Loading experience messages'
    resourceLoaded={() => props.loadExperienceMessages()} />
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const {id: experienceId} = ownProps.experience
  return {
    loadExperienceMessages: () => dispatch(experienceMessageActions.loadAll({experienceId}))
  }
}

const mapStateToProps = (state, ownProps) => {
  const {id: experienceId} = ownProps.experience

  const messagesForExperience = experienceMessageSelectors
    .byExperienceId(state, experienceId)
    .sortBy(message => message.createdAt)
    .reverse()
    .take(3)

  return {
    messagesForExperience
  }
}

export const Messages = connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadableMessages)
